'use client';

import { memo } from 'react';
import {
  ShoppingCart, TrendingUp, Briefcase, Globe, Shield,
  BookOpen, Biohazard, FlaskConical, Calculator,
} from 'lucide-react';
import { Subject } from '@/lib/games-data';

const ICON_MAP: Record<string, React.ElementType> = {
  ShoppingCart, TrendingUp, Briefcase, Globe, Shield,
  BookOpen, Biohazard, FlaskConical, Calculator,
};

interface SubjectCardProps {
  subject: Subject;
  onPlay: (subject: Subject) => void;
}

const SubjectCard = memo(function SubjectCard({ subject, onPlay }: SubjectCardProps) {
  const Icon = ICON_MAP[subject.icon] ?? BookOpen;

  return (
    <div
      className={`${subject.gradient} rounded-3xl p-8 text-white relative overflow-hidden flex flex-col shadow-xl ${subject.shadowColor} h-64`}
    >
      <div className="absolute right-0 bottom-0 opacity-10 text-white pointer-events-none -mr-4 -mb-4">
        <Icon className="w-40 h-40" strokeWidth={1} />
      </div>

      <div className="relative z-10 flex-1">
        <h3 className="font-bold mb-3 leading-tight text-xl whitespace-pre-line">
          {subject.title}
        </h3>
        <p className="text-white/80 text-sm max-w-xs">{subject.description}</p>
      </div>

      <button
        onClick={() => onPlay(subject)}
        className="relative z-10 bg-teal-600 py-3 rounded-2xl font-bold text-sm self-start hover:bg-teal-500 transition-colors tracking-wide px-6"
      >
        PLAY GAME
      </button>
    </div>
  );
});

export default SubjectCard;
